<template>
  <div class="circular-graph">
    <div ref="chartDom" style="width: 100%; height: 300px"></div>
  </div>
</template>

<script>
const echarts = require('echarts/lib/echarts')
require('echarts/lib/component/title')
require('echarts/lib/component/tooltip')
require('echarts/lib/component/legend')
require('echarts/lib/chart/pie')
export default {
  props: {
    graphData: {
      type: Array,
      default() {}
    },
    isNoData: {
      // 是否有数据
      type: Boolean,
      default() {
        return true
      }
    }
  },
  watch: {
    graphData() {
      this.init()
    }
  },
  data() {
    return {
      chartDom: null,
      myChart: null,
      option: {},
      showTitle: false
    }
  },
  mounted() {
    this.chartDom = this.$refs.chartDom
    this.myChart = echarts.init(this.chartDom)
    this.init()
  },
  methods: {
    init() {
      this.option = {
        title: {
          show: this.isNoData, // 没数据时显示title
          text: '暂无数据',
          left: 'center',
          top: 'center',
          textStyle: {
            color: 'pink',
            fontSize: 16,
            fontWeight: 400
          }
        },
        bottom: '25%',
        tooltip: {
          trigger: 'item',
          formatter: '{b}<br />{d}%'
        },
        legend: {
          bottom: '0%',
          left: 'center'
        },
        series: [
          {
            name: '交易数据',
            type: 'pie',
            radius: ['30%', '45%'],
            center: ['50%', '45%'],
            data: this.graphData,
            itemStyle: {
              normal: {
                label: {
                  formatter: `{d}%
{b}`
                }
              }
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
      this.option && this.myChart.setOption(this.option)
    }
  }
}
</script>

<style lang="less" scoped></style>
